import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";
import { useGetDatasetIsReadyForSearch } from "../services/DatasetServices";
import { useDatasetViewerStore } from "../stores/DatasetViewerStore";
import { useEffect } from "react";

const SearchIndexInfo = ({ datasetId }: { datasetId: number }) => {
  const { data: SDREmbeddedCounts } = useGetDatasetIsReadyForSearch({
    datasetId: datasetId,
  });

  const setIsIndexed = useDatasetViewerStore((state) => state.setIsIndexed);

  const numSdrNotEmbedded = SDREmbeddedCounts?.num_sdr_not_embedded ?? 0;

  const notFullyIndexed = numSdrNotEmbedded > 0;

  useEffect(() => {
    setIsIndexed(!notFullyIndexed);
  }, [notFullyIndexed, setIsIndexed]);

  // Don't render anything if fully indexed
  if (!notFullyIndexed) {
    return null;
  }

  return (
    <Tooltip
      title={`${numSdrNotEmbedded} document${
        numSdrNotEmbedded === 1 ? "" : "s"
      } being indexed for search. This happens automatically in the background.`}
      arrow
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          backgroundColor: "action.hover",
          cursor: "default",
        }}
      >
        <CircularProgress size={12} thickness={4} />
        <Typography variant="caption" color="text.secondary">
          Indexing {numSdrNotEmbedded}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default SearchIndexInfo;
